import { Star } from 'lucide-react';

interface Props {
  value: number;
  /** When provided, the stars become an interactive picker. */
  onChange?: (value: number) => void;
  size?: number;
}

/** A 1–5 star rating — read-only by default, interactive when `onChange` is given. */
export default function StarRating({ value, onChange, size = 16 }: Props) {
  return (
    <div className="flex items-center">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={!onChange}
          onClick={() => onChange?.(n)}
          aria-label={`${n} star${n > 1 ? 's' : ''}`}
          className={onChange ? 'cursor-pointer p-0.5' : 'cursor-default'}
        >
          <Star
            style={{ width: size, height: size }}
            className={n <= value ? 'fill-yellow-400 text-yellow-400' : 'text-fg-faint'}
          />
        </button>
      ))}
    </div>
  );
}
